// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --df-primary: #0B3A5C;
  --df-primary-hover: #0E4A73;
  --df-primary-muted: #1A5270;
  --df-accent: #E85D04;
  --df-accent-hover: #D45203;
  --df-success: #0F7B5A;
  --df-warning: #C47F17;
  --df-error: #C0392B;
  --df-info: #1A6B8A;
  --df-surface: #F4F7FA;
  --df-surface-elevated: rgba(255, 255, 255, 0.96);
  --df-card: #FFFFFF;
  --df-border: #D7E0EA;
  --df-border-subtle: #E8EEF4;
  --df-text: #122033;
  --df-text-secondary: #5B6B7C;
  --df-text-muted: #8494A7;
  --df-header-bg: #0B3A5C;
  --df-header-fg: #F4F7FA;
  --df-radius: 10px;
  --df-radius-lg: 12px;
  --df-font-display: 'Sora', 'Segoe UI', sans-serif;
  --df-font-body: 'Source Sans 3', 'Segoe UI', sans-serif;
  --df-shadow: 0 1px 2px rgba(18, 32, 51, 0.05), 0 1px 3px rgba(18, 32, 51, 0.04);
  --df-shadow-hover: 0 10px 28px rgba(11, 58, 92, 0.1), 0 3px 8px rgba(18, 32, 51, 0.05);
  --df-ease: cubic-bezier(0.4, 0, 0.2, 1);
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

body {
  font-family: var(--df-font-body);
  line-height: 1.55;
  color: var(--df-text);
  background:
    radial-gradient(1200px 600px at 8% -10%, rgba(11, 58, 92, 0.07), transparent 55%),
    radial-gradient(900px 500px at 92% 0%, rgba(232, 93, 4, 0.05), transparent 50%),
    linear-gradient(180deg, #F7FAFC 0%, var(--df-surface) 40%, #EEF3F8 100%);
  background-attachment: fixed;
  min-height: 100vh;
}

#root {
  min-height: 100vh;
}

a {
  text-decoration: none;
  color: inherit;
}

img {
  max-width: 100%;
  height: auto;
  display: block;
}

:focus-visible {
  outline: 2px solid var(--df-accent);
  outline-offset: 2px;
}

button:focus-visible,
a:focus-visible,
[role="button"]:focus-visible,
[role="link"]:focus-visible,
.ant-btn:focus-visible,
.ant-input:focus-visible,
.ant-input-affix-wrapper:focus-within {
  outline: 2px solid var(--df-accent);
  outline-offset: 2px;
}

.ant-btn-primary:focus-visible {
  outline-color: var(--df-accent);
}

/* Page surface panels */
.df-surface-panel {
  background: var(--df-surface-elevated);
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(11, 58, 92, 0.18);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(11, 58, 92, 0.28);
}

::selection {
  background: rgba(11, 58, 92, 0.14);
  color: var(--df-primary);
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--df-font-display);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--df-text);
}

p {
  line-height: 1.65;
  color: var(--df-text-secondary);
}

/* Brand mark */
.df-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  animation: df-brand-reveal 0.55s var(--df-ease) both;
}

.df-brand__mark {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: linear-gradient(145deg, var(--df-accent) 0%, #F48C06 100%);
  color: #fff;
  font-family: var(--df-font-display);
  font-weight: 700;
  font-size: 13px;
  letter-spacing: -0.04em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(232, 93, 4, 0.35);
  flex-shrink: 0;
}

.df-brand__wordmark {
  font-family: var(--df-font-display);
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: var(--df-header-fg);
  line-height: 1;
}

.df-brand--dark .df-brand__wordmark {
  color: var(--df-primary);
}

@keyframes df-brand-reveal {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Deal card motion */
.df-deal-card {
  background: var(--df-surface-elevated);
  border: 1px solid var(--df-border);
  border-radius: var(--df-radius-lg);
  overflow: hidden;
  box-shadow: var(--df-shadow);
  transition: box-shadow 0.22s var(--df-ease), transform 0.22s var(--df-ease), border-color 0.22s var(--df-ease);
}

.df-deal-card:hover {
  box-shadow: var(--df-shadow-hover);
  transform: translateY(-3px);
  border-color: #C5D3E0;
}

.df-feed-item {
  animation: df-feed-in 0.4s var(--df-ease) both;
}

.df-feed-item:nth-child(1) { animation-delay: 0.03s; }
.df-feed-item:nth-child(2) { animation-delay: 0.06s; }
.df-feed-item:nth-child(3) { animation-delay: 0.09s; }
.df-feed-item:nth-child(4) { animation-delay: 0.12s; }
.df-feed-item:nth-child(5) { animation-delay: 0.15s; }
.df-feed-item:nth-child(6) { animation-delay: 0.18s; }

@keyframes df-feed-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Auth atmosphere shell */
.df-auth-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(800px 480px at 15% 10%, rgba(11, 58, 92, 0.12), transparent 55%),
    radial-gradient(700px 420px at 90% 85%, rgba(232, 93, 4, 0.1), transparent 50%),
    linear-gradient(165deg, #E8F0F6 0%, #F4F7FA 45%, #EAF0F5 100%);
}

.df-auth-panel {
  width: 420px;
  max-width: 100%;
  background: var(--df-surface-elevated);
  border: 1px solid var(--df-border);
  border-radius: 14px;
  box-shadow: 0 16px 48px rgba(11, 58, 92, 0.1);
  overflow: hidden;
}

.df-auth-panel__inner {
  padding: 40px 40px 36px;
}

/* Layout chrome */
.df-header {
  background: var(--df-header-bg) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 0 20px !important;
  height: 68px !important;
  line-height: 68px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: saturate(1.2);
}

.df-header__search .ant-input-affix-wrapper,
.df-header__search.ant-input-affix-wrapper {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.16) !important;
  color: #fff !important;
}

.df-header__search .ant-input {
  background: transparent !important;
  color: #fff !important;
}

.df-header__search .ant-input::placeholder {
  color: rgba(244, 247, 250, 0.55);
}

.df-main {
  max-width: 1180px;
  margin: 0 auto;
  width: 100%;
  padding: 28px 20px 48px;
}

.df-footer {
  text-align: center;
  padding: 36px 20px;
  background: var(--df-primary);
  color: rgba(244, 247, 250, 0.65);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.df-footer a {
  color: rgba(244, 247, 250, 0.85);
  transition: color 0.2s var(--df-ease);
}

.df-footer a:hover {
  color: #fff;
}

.df-discovery-hero {
  margin-bottom: 28px;
  padding: 8px 2px 4px;
}

.df-discovery-hero__brand {
  margin-bottom: 10px;
}

.df-discovery-hero h1 {
  font-size: clamp(1.6rem, 3vw, 2.1rem);
  margin: 0 0 8px;
  max-width: 28ch;
}

.df-discovery-hero p {
  margin: 0;
  max-width: 48ch;
  font-size: 1.05rem;
}

/* Utilities */
.text-primary { color: var(--df-primary); }
.text-accent { color: var(--df-accent); }
.text-success { color: var(--df-success); }
.text-warning { color: var(--df-warning); }
.text-error { color: var(--df-error); }
.text-secondary { color: var(--df-text-secondary); }

.shadow-card {
  box-shadow: var(--df-shadow);
}

.shadow-card-hover {
  box-shadow: var(--df-shadow-hover);
}

.button-transition {
  transition: background 0.2s var(--df-ease), border-color 0.2s var(--df-ease), box-shadow 0.2s var(--df-ease);
}

@media (max-width: 768px) {
  .df-header {
    padding: 0 12px !important;
  }

  .df-main {
    padding: 16px 12px 40px;
  }

  .df-auth-panel__inner {
    padding: 28px 22px 24px;
  }

  .df-header__nav {
    display: none !important;
  }

  .df-header__search {
    width: 140px !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./apps/web/src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gDAAgD;EAChD,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,iDAAiD;EACjD,uDAAuD;EACvD,+EAA+E;EAC/E,sFAAsF;EACtF,uCAAuC;AACzC;;AAEA;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;EACrB;;;4EAG0E;EAC1E,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sEAAsE;EACtE,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,sCAAsC;EACtC,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,4BAA4B;EAC5B,8GAA8G;AAChH;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;;AAErD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb;;;kEAGgE;AAClE;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,0CAA0C;EAC1C,kDAAkD;EAClD,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;EAEE,+CAA+C;EAC/C,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA,cAAc;AACd,gBAAgB,wBAAwB,EAAE;AAC1C,eAAe,uBAAuB,EAAE;AACxC,gBAAgB,wBAAwB,EAAE;AAC1C,gBAAgB,wBAAwB,EAAE;AAC1C,cAAc,sBAAsB,EAAE;AACtC,kBAAkB,+BAA+B,EAAE;;AAEnD;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4GAA4G;AAC9G;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":[":root {\n  --df-primary: #0B3A5C;\n  --df-primary-hover: #0E4A73;\n  --df-primary-muted: #1A5270;\n  --df-accent: #E85D04;\n  --df-accent-hover: #D45203;\n  --df-success: #0F7B5A;\n  --df-warning: #C47F17;\n  --df-error: #C0392B;\n  --df-info: #1A6B8A;\n  --df-surface: #F4F7FA;\n  --df-surface-elevated: rgba(255, 255, 255, 0.96);\n  --df-card: #FFFFFF;\n  --df-border: #D7E0EA;\n  --df-border-subtle: #E8EEF4;\n  --df-text: #122033;\n  --df-text-secondary: #5B6B7C;\n  --df-text-muted: #8494A7;\n  --df-header-bg: #0B3A5C;\n  --df-header-fg: #F4F7FA;\n  --df-radius: 10px;\n  --df-radius-lg: 12px;\n  --df-font-display: 'Sora', 'Segoe UI', sans-serif;\n  --df-font-body: 'Source Sans 3', 'Segoe UI', sans-serif;\n  --df-shadow: 0 1px 2px rgba(18, 32, 51, 0.05), 0 1px 3px rgba(18, 32, 51, 0.04);\n  --df-shadow-hover: 0 10px 28px rgba(11, 58, 92, 0.1), 0 3px 8px rgba(18, 32, 51, 0.05);\n  --df-ease: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: var(--df-font-body);\n  line-height: 1.55;\n  color: var(--df-text);\n  background:\n    radial-gradient(1200px 600px at 8% -10%, rgba(11, 58, 92, 0.07), transparent 55%),\n    radial-gradient(900px 500px at 92% 0%, rgba(232, 93, 4, 0.05), transparent 50%),\n    linear-gradient(180deg, #F7FAFC 0%, var(--df-surface) 40%, #EEF3F8 100%);\n  background-attachment: fixed;\n  min-height: 100vh;\n}\n\n#root {\n  min-height: 100vh;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n:focus-visible {\n  outline: 2px solid var(--df-accent);\n  outline-offset: 2px;\n}\n\nbutton:focus-visible,\na:focus-visible,\n[role=\"button\"]:focus-visible,\n[role=\"link\"]:focus-visible,\n.ant-btn:focus-visible,\n.ant-input:focus-visible,\n.ant-input-affix-wrapper:focus-within {\n  outline: 2px solid var(--df-accent);\n  outline-offset: 2px;\n}\n\n.ant-btn-primary:focus-visible {\n  outline-color: var(--df-accent);\n}\n\n/* Page surface panels */\n.df-surface-panel {\n  background: var(--df-surface-elevated);\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(11, 58, 92, 0.18);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(11, 58, 92, 0.28);\n}\n\n::selection {\n  background: rgba(11, 58, 92, 0.14);\n  color: var(--df-primary);\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--df-font-display);\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: var(--df-text);\n}\n\np {\n  line-height: 1.65;\n  color: var(--df-text-secondary);\n}\n\n/* Brand mark */\n.df-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  animation: df-brand-reveal 0.55s var(--df-ease) both;\n}\n\n.df-brand__mark {\n  width: 36px;\n  height: 36px;\n  border-radius: 9px;\n  background: linear-gradient(145deg, var(--df-accent) 0%, #F48C06 100%);\n  color: #fff;\n  font-family: var(--df-font-display);\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: -0.04em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(232, 93, 4, 0.35);\n  flex-shrink: 0;\n}\n\n.df-brand__wordmark {\n  font-family: var(--df-font-display);\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  color: var(--df-header-fg);\n  line-height: 1;\n}\n\n.df-brand--dark .df-brand__wordmark {\n  color: var(--df-primary);\n}\n\n@keyframes df-brand-reveal {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Deal card motion */\n.df-deal-card {\n  background: var(--df-surface-elevated);\n  border: 1px solid var(--df-border);\n  border-radius: var(--df-radius-lg);\n  overflow: hidden;\n  box-shadow: var(--df-shadow);\n  transition: box-shadow 0.22s var(--df-ease), transform 0.22s var(--df-ease), border-color 0.22s var(--df-ease);\n}\n\n.df-deal-card:hover {\n  box-shadow: var(--df-shadow-hover);\n  transform: translateY(-3px);\n  border-color: #C5D3E0;\n}\n\n.df-feed-item {\n  animation: df-feed-in 0.4s var(--df-ease) both;\n}\n\n.df-feed-item:nth-child(1) { animation-delay: 0.03s; }\n.df-feed-item:nth-child(2) { animation-delay: 0.06s; }\n.df-feed-item:nth-child(3) { animation-delay: 0.09s; }\n.df-feed-item:nth-child(4) { animation-delay: 0.12s; }\n.df-feed-item:nth-child(5) { animation-delay: 0.15s; }\n.df-feed-item:nth-child(6) { animation-delay: 0.18s; }\n\n@keyframes df-feed-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Auth atmosphere shell */\n.df-auth-shell {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background:\n    radial-gradient(800px 480px at 15% 10%, rgba(11, 58, 92, 0.12), transparent 55%),\n    radial-gradient(700px 420px at 90% 85%, rgba(232, 93, 4, 0.1), transparent 50%),\n    linear-gradient(165deg, #E8F0F6 0%, #F4F7FA 45%, #EAF0F5 100%);\n}\n\n.df-auth-panel {\n  width: 420px;\n  max-width: 100%;\n  background: var(--df-surface-elevated);\n  border: 1px solid var(--df-border);\n  border-radius: 14px;\n  box-shadow: 0 16px 48px rgba(11, 58, 92, 0.1);\n  overflow: hidden;\n}\n\n.df-auth-panel__inner {\n  padding: 40px 40px 36px;\n}\n\n/* Layout chrome */\n.df-header {\n  background: var(--df-header-bg) !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 0 20px !important;\n  height: 68px !important;\n  line-height: 68px !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  backdrop-filter: saturate(1.2);\n}\n\n.df-header__search .ant-input-affix-wrapper,\n.df-header__search.ant-input-affix-wrapper {\n  background: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.16) !important;\n  color: #fff !important;\n}\n\n.df-header__search .ant-input {\n  background: transparent !important;\n  color: #fff !important;\n}\n\n.df-header__search .ant-input::placeholder {\n  color: rgba(244, 247, 250, 0.55);\n}\n\n.df-main {\n  max-width: 1180px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 28px 20px 48px;\n}\n\n.df-footer {\n  text-align: center;\n  padding: 36px 20px;\n  background: var(--df-primary);\n  color: rgba(244, 247, 250, 0.65);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.df-footer a {\n  color: rgba(244, 247, 250, 0.85);\n  transition: color 0.2s var(--df-ease);\n}\n\n.df-footer a:hover {\n  color: #fff;\n}\n\n.df-discovery-hero {\n  margin-bottom: 28px;\n  padding: 8px 2px 4px;\n}\n\n.df-discovery-hero__brand {\n  margin-bottom: 10px;\n}\n\n.df-discovery-hero h1 {\n  font-size: clamp(1.6rem, 3vw, 2.1rem);\n  margin: 0 0 8px;\n  max-width: 28ch;\n}\n\n.df-discovery-hero p {\n  margin: 0;\n  max-width: 48ch;\n  font-size: 1.05rem;\n}\n\n/* Utilities */\n.text-primary { color: var(--df-primary); }\n.text-accent { color: var(--df-accent); }\n.text-success { color: var(--df-success); }\n.text-warning { color: var(--df-warning); }\n.text-error { color: var(--df-error); }\n.text-secondary { color: var(--df-text-secondary); }\n\n.shadow-card {\n  box-shadow: var(--df-shadow);\n}\n\n.shadow-card-hover {\n  box-shadow: var(--df-shadow-hover);\n}\n\n.button-transition {\n  transition: background 0.2s var(--df-ease), border-color 0.2s var(--df-ease), box-shadow 0.2s var(--df-ease);\n}\n\n@media (max-width: 768px) {\n  .df-header {\n    padding: 0 12px !important;\n  }\n\n  .df-main {\n    padding: 16px 12px 40px;\n  }\n\n  .df-auth-panel__inner {\n    padding: 28px 22px 24px;\n  }\n\n  .df-header__nav {\n    display: none !important;\n  }\n\n  .df-header__search {\n    width: 140px !important;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
